"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
const provider_test_id_1 = require("@framework/provider-test-id");
const TextInput = props => {
    const { name, label, showLabel = true, readOnly, inputProps, InputProps, placeholder, formatValue, normalizeValue, variant = "standard", type, ...rest } = props;
    const { testId } = (0, provider_test_id_1.useTestId)();
    const testIdProps = testId ? { "data-testid": `${testId}-${name}` } : {};
    const suffix = name.split(".").pop();
    const form = (0, react_hook_form_1.useFormContext)();
    const error = (0, react_hook_form_1.get)(form.formState.errors, name);
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const localizedLabel = label ?? formatMessage({ id: `form.labels.${suffix}` });
    const localizedPlaceholder = placeholder ?? formatMessage({ id: `form.placeholders.${suffix}` });
    const localizedHelperText = error ? formatMessage({ id: error.message }, { label: localizedLabel }) : "";
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: name, control: form.control, render: ({ field }) => {
            return ((0, jsx_runtime_1.jsx)(material_1.TextField, { sx: { my: 1 }, label: showLabel ? localizedLabel : "", placeholder: localizedPlaceholder, helperText: localizedHelperText || "\u00A0", error: Boolean(error), variant: variant, type: type, fullWidth: true, InputProps: {
                    ...InputProps,
                }, inputProps: {
                    readOnly,
                    ...inputProps,
                    ...testIdProps,
                }, inputRef: InputProps?.inputRef, ...field, value: (() => {
                    const raw = field.value ?? "";
                    const normalizedValue = normalizeValue
                        ? normalizeValue(raw)
                        : raw;
                    return normalizedValue;
                })(), onChange: (e) => {
                    const newValue = formatValue ? formatValue(e.target.value) : e.target.value;
                    form.setValue(name, newValue, {
                        shouldTouch: true,
                        shouldDirty: true,
                        shouldValidate: true,
                    });
                    if (name === "newPassword") {
                        void form.trigger(["newPassword", "confirmPassword"]);
                    }
                    else {
                        void form.trigger(name);
                    }
                }, ...rest }));
        } }));
};
exports.TextInput = TextInput;
//# sourceMappingURL=index.js.map